import React, { useState } from "react";
import { useForm, ValidationError } from "@formspree/react";
import "./contact.css";

const ContactForm = () => {
  const [isSent, setIsSent] = useState(false);
  const [state, handleSubmit] = useForm("mzzzknkn");

  if (state.succeeded) {
    return (
      <div className="thank-you-message">
        <h2>Thank you for your message!</h2>
        <p>We will respond within a few days. In the meantime, you can check our <a href="/faq">FAQ page</a> to see if your question has already been answered.</p>
      </div>
    );
  }

  return (
    <div className="formy2">
      <div className="formy">
        <div className={isSent ? "contact-sent" : "contact-form"}>
          <form onSubmit={handleSubmit}>
            <div className="contact-wrapper">
              <article className="contact-letter">
                <div className="contact-side">
                  <h1>Contact us</h1>
                  <p>
                    <textarea
                      id="message"
                      name="message"
                      placeholder="Your message"
                    ></textarea>
                    <ValidationError
                      prefix="Message"
                      field="message"
                      errors={state.errors}
                    />
                  </p>
                </div>
                <div className="contact-side">
                  <p>
                    <input
                      className="contact-input"
                      type="text"
                      id="name"
                      name="name"
                      placeholder="Your name"
                    />
                  </p>
                  <ValidationError
                    prefix="Name"
                    field="name"
                    errors={state.errors}
                  />
                  <p>
                    <input
                      className="contact-input"
                      type="email"
                      id="email"
                      name="email"
                      placeholder="Your email"
                    />
                  </p>
                  <ValidationError
                    prefix="Email"
                    field="email"
                    errors={state.errors}
                  />
                  <p>
                    <button type="submit" disabled={state.submitting}>
                      Send
                    </button>
                  </p>
                </div>
              </article>
            </div>
            <div className="contact-envelope front"></div>
            <div className="contact-envelope back"></div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ContactForm;
